import React from 'react';
import CopyButton from '../common/CopyButton';

const ReferralLink = ({ userId }) => {
  if (!userId) return null;
  const link = `${window.location.origin}/?ref=${userId}`;
  return (
    <div className="card">
      <div className="card-title">Your Referral Link</div>
      <div className="referral-block" style={{ marginTop: 6 }}>
        <code>{link}</code>
        <CopyButton text={link} label="Copy link" />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, fontSize: 12, color: 'var(--text-muted)' }}>
        <span>Your ID</span>
        <strong style={{ color: 'var(--bnb-yellow)', fontFamily: 'var(--font-display)' }}>#{userId}</strong>
      </div>
    </div>
  );
};

export default ReferralLink;
